// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane_pane__h9PPS"};